import { createAsyncThunk } from "@reduxjs/toolkit";

export const getVehicleTypeList = createAsyncThunk(
    "getVehicleTypeList",
    async (token) => {
        const response = await fetch(
            `https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_get_VehicleType`,
            {
                method: "POST",
                headers: new Headers({
                    "Authorization": `${token}`,
                    'Content-Type': 'application/json'
                }),
            }
        );
        return response.json();
    }
);